document.addEventListener('DOMContentLoaded', function () {
  const card = document.querySelector('.main_try_free_bottom');
  if (!card) return;

  // The card is pulled onto the block above with `transform: translateY(-50%)`. A transform does
  // not affect layout flow, so half of the card's height stays as empty space below it — and that
  // half is a moving target (it depends on the content and the breakpoint). We collapse that
  // leftover with a negative margin-bottom so the gap under the card is a fixed, controllable
  // value on every breakpoint, while the overlap above stays exactly 50% of the card's height.
  const DESKTOP_GAP = 100;
  const MOBILE_GAP = 60;
  const mobileQuery = window.matchMedia('(max-width: 667px)');

  function updateSpacing() {
    const gap = mobileQuery.matches ? MOBILE_GAP : DESKTOP_GAP;
    const height = card.offsetHeight; // border-box height — excludes the margin we set, no feedback loop
    card.style.marginBottom = gap - height / 2 + 'px';
  }

  updateSpacing();
  window.addEventListener('load', updateSpacing);
  window.addEventListener('resize', updateSpacing);

  // Recalculate when the card itself reflows (fonts/images loading, content changes).
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(updateSpacing).observe(card);
  }
});
